/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { MenuAlt1Icon, SearchIcon } from '@heroicons/react/solid';
import { LogoutIcon } from '@heroicons/react/outline';
import {
  Nav,
  Form,
  Image,
  Button,
  Navbar,
  Dropdown,
  Container,
  InputGroup,
} from 'react-bootstrap';

interface IDropDownItem {
  id: string;
  icon: string;
  label: string;
}

export interface ITopbarProps {
  searchbar?: boolean;
  userImage?: string;
  userName?: string;
  dropDownItems?: IDropDownItem[];
  logoutLabel?: string;
  onDropDownItemClick?(item: IDropDownItem): void;
}

//TODO: Notifications in top bar

export const Topbar = (props: any & ITopbarProps) => {
  const toggleContracted = () =>
    props.toggleContracted && props.toggleContracted();

  return (
    <Navbar
      expand
      variant="dark"
      className="navbar-top navbar-dashboard ps-0 pe-2 pb-0"
    >
      <Container fluid className="px-0">
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex align-items-center">
            <Button
              size="lg"
              id="sidebar-toggle"
              variant="icon-only"
              className="sidebar-toggle d-none d-lg-inline-block align-items-center justify-content-center me-3"
              onClick={toggleContracted}
            >
              <MenuAlt1Icon className="toggle-icon" />
            </Button>
            {props.searchbar && (
              <Form className="navbar-search form-inline">
                <Form.Group id="topbarSearch">
                  <InputGroup className="input-group-merge search-bar">
                    <InputGroup.Text>
                      <SearchIcon className="icon icon-xs" />
                    </InputGroup.Text>
                    <Form.Control type="text" placeholder="Search" />
                  </InputGroup>
                </Form.Group>
              </Form>
            )}
          </div>
          <Nav className="align-items-center">
            <Dropdown as={Nav.Item} className="ms-lg-3">
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  {props.userImage && (
                    <Image
                      src={props.userImage}
                      className="avatar rounded-circle"
                    />
                  )}
                  {props.userName && (
                    <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                      <span className="mb-0 font-small fw-bold text-gray-900">
                        {props.userName}
                      </span>
                    </div>
                  )}
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dashboard-dropdown dropdown-menu-end mt-2 py-1">
                {props.dropDownItems?.map((dditem, index) => {
                  if (dditem?.icon) {
                    const HeroIcon = require('@heroicons/react/solid');
                    const DDIcon = HeroIcon[dditem.icon];
                    if (DDIcon) {
                      return (
                        <Dropdown.Item
                          key={`dditem-${index}`}
                          className="d-flex align-items-center"
                          onClick={props.onDropDownItemClick?.bind(
                            null,
                            dditem
                          )}
                        >
                          <DDIcon className="dropdown-icon text-gray-400 me-2" />
                          {dditem?.label}
                        </Dropdown.Item>
                      );
                    }
                  }
                })}
                {props?.dropDownItems?.length && (
                  <Dropdown.Divider as="div" className="my-1" />
                )}
                <Dropdown.Item
                  className="d-flex align-items-center"
                  onClick={props.onDropDownItemClick?.bind(null, {
                    id: 'logout',
                    label: props.logoutLabel,
                  })}
                >
                  <LogoutIcon className="dropdown-icon text-danger me-2" />{' '}
                  {props.logoutLabel}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};

Topbar.defaultProps = {
  searchbar: false,
  logoutLabel: 'Logout',
};
